module.exports = __webpack_public_path__ + "0ad03a50aa2f06d5f1a35e9391815488.svg";